/**
 * Normalises assorted representations of the Jira flag field into a boolean.
 * Accepted truthy representations:
 *  - boolean true
 *  - non-empty array
 *  - string 'true'
 *  - stringified array (single or double quotes) with at least one element e.g. "['Impediment']" / '["Impediment"]'
 * Everything else (including malformed / non-parsable bracketed strings) is treated as unflagged.
 */
export function isFlagged(value: unknown): boolean {
	if (value === true) {
		return true;
	}
	if (value === false || value == null) {
		return false;
	}

	if (Array.isArray(value)) {
		return value.length > 0 && value.includes('Impediment');
	}

	if (typeof value === 'string') {
		const stringValue = value.trim();
		if (stringValue === 'true') {
			return true;
		}
		if (stringValue === 'false' || stringValue === '' || stringValue === '[]') {
			return false;
		}

		// Heuristic: looks like an array string
		if (stringValue.startsWith('[') && stringValue.endsWith(']')) {
			let candidate = stringValue;
			// If it only has single quotes, convert to double quotes for JSON.parse
			if (!stringValue.includes('"') && stringValue.includes("'")) {
				candidate = stringValue.replace(/'/g, '"');
			}
			try {
				const parsed = JSON.parse(candidate);
				if (Array.isArray(parsed)) {
					return parsed.length > 0 && parsed.includes('Impediment');
				}
			} catch {
				// Parsing failed – treat malformed bracketed content as unflagged now.
				return false;
			}
			// Non‑array parsed result -> not flagged
			return false;
		}
	}

	return false;
}

export default isFlagged;
